import { render, staticRenderFns } from "./ConfigurationConfigView.vue?vue&type=template&id=381c2dd0"
import script from "./ConfigurationConfigView.vue?vue&type=script&lang=js"
export * from "./ConfigurationConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports